import * as HLF from "html-living-framework";

export class FlyingGameProgressBar extends PIXI.Container {

    public nextRestStop?: PIXI.Sprite;

    protected fill?: PIXI.NineSlicePlane;
    protected maxWidth: number = 0;
    protected minWidth: number = 0;

    protected fillContainer = this.addChild(new PIXI.Container());
    protected restStopContainer = this.addChild(new PIXI.Container());

    protected duration: number | undefined;

    protected restStops: PIXI.Sprite[] = [];

    protected nextRestStopTime: number = 0;

    public constructor () {
        super();
    }

    public update(pDeltaTime: number) {
        if (this.duration && this.fill) {
            this.fill.width += ((this.maxWidth - this.minWidth) / this.duration) * pDeltaTime;
            if (this.fill.width > this.maxWidth) {
                this.duration = undefined;
            }
        }
    }

    public setForegroundTexture(pTexture: PIXI.Texture, pLeftWidth: number, pRightWidth: number) {
        this.fill = new PIXI.NineSlicePlane(pTexture, pLeftWidth, 0, pRightWidth, 0);
        this.fillContainer.position.x = -this.fill.width / 2;
        this.fillContainer.position.y = -this.fill.height / 2;
        this.maxWidth = this.fill.width;
        this.minWidth = 0;

        this.fillContainer.addChild(this.fill);

        this.restStopContainer.position.copyFrom(this.fillContainer.position);
    }

    public setDuration(pDuration: number) {
        this.duration = pDuration;
    }

    public setProgress(pProgress: number) {
        if (this.duration && this.fill) {
            this.fill.width = this.minWidth + (this.maxWidth - this.minWidth) * (pProgress / this.duration);
        }
    }

    public addRestStop(pOptions: {time: number, sprite: PIXI.Sprite, visited: boolean}) {
        const restStop = this.restStopContainer.addChild(PIXI.Sprite.from(pOptions.sprite.texture));
        restStop.anchor.copyFrom(pOptions.sprite.anchor);
        restStop.position.y = this.restStopContainer.toLocal(pOptions.sprite.getGlobalPosition()).y;
        restStop.x = (this.minWidth / 2) + (this.maxWidth - this.minWidth) * (pOptions.time / this.duration!);
        this.restStops.push(restStop);

        if (pOptions.visited === false) {
            if (this.nextRestStop === undefined) {
                this.nextRestStop = restStop;
                this.nextRestStopTime = pOptions.time;
            }
            else if (pOptions.time < this.nextRestStopTime) {
                this.nextRestStop = restStop;
                this.nextRestStopTime = pOptions.time;
            }
        }
        return restStop;
    }
}